




































































































import MixinMainWindow from '@/components/Cartable/ComponentMixins/MixinMainWindow';
import CartableTitleMobile from '@/components/MobileComponents/CartableTitleMobile/CartableTitleMobile.vue';
import QuickAccessMobile from '@/components/MobileComponents/QuickAccessMobile/QuickAccessMobile.vue';
import FoldersTreeMobile from '@/components/MobileComponents/FoldersTreeMobile/FoldersTreeMobile.vue';
import LetterDetailsMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterDetailsMobile.vue';
import EnterpriseFormLists from '@/components/MobileComponents/EnterpriseFormLists/EnterpriseFormLists.vue';
import LetterListRouterView from '@/components/MobileComponents/LetterListRouterView/LetterListRouterView.vue';
import store from '@/store';
import {LetterSearchResult } from '@/store/models/Letter/LetterSearchResult';
import * as enterpriseFormService from '@/store/Services/enterpriseFormService';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import * as $ from 'jquery';
import {Letter} from '@/store/models/Letter/Letter';
import { DraftLetter } from '@/store/models/Letter/DraftLetter';
import { EnterpriseForm } from '@/store/models/EnterpriseForm/EnterpriseForm';
import { NextFormInfo } from '@/store/models/EnterpriseForm/NextFormInfo';
import { DraftEnterpriseFormInfo } from '@/store/models/EnterpriseForm/LoadEnterpriseFormDraftResponse';
import router from '@/router';
import SendEnterpriseFormMobile from '@/components/MobileComponents/EnterpriseFormMobile/SendEnterpriseFormMobile.vue';
import FastSendMobile from '@/components/MobileComponents/FastSendMobile/FastSendMobile.vue';
import ForwardLetterMobile from '@/components/MobileComponents/ForwardLetterMobile/ForwardLetterMobile.vue';
import FinalizeLetterMobile from '@/components/MobileComponents/LetterDetailsMobile/FinalizeLetterMobile/FinalizeLetterMobile.vue';
import DraftDetailsMobile from '@/components/MobileComponents/DraftDetailsMobile/DraftDetailsMobile.vue';


@Component({
    components:{ForwardLetterMobile,FastSendMobile,CartableTitleMobile,QuickAccessMobile,FoldersTreeMobile,LetterDetailsMobile,EnterpriseFormLists,LetterListRouterView,SendEnterpriseFormMobile,FinalizeLetterMobile,DraftDetailsMobile}
})
export default class MainWindowMobile extends Mixins(MixinMainWindow) {

    shallShowentErpriseFormLists=false;
    shallShowLetterListRouter=false;
    shallshowparentcomponent=true;
    shallShowSingleEnterpriseForm=false;
    shallRouteToReciveLettersForm=false;

    created(){
        store.state.eventHub.$on('set-selected-letter-changed',this.onSetSelectdLetterChangedLetterListView)
        store.state.eventHub.$on('close-finalizeLetter',this.onCloseFinalizeLetter)
    }
    async mounted(){
        this.shallShowentErpriseFormLists==false;
        // this.shallShowLetterListRouter==true;
    //    alert("test");
           $('.mainWindowMobile').sidebar({
            context: $('.bottom.segment')
          }).sidebar('attach events','.sidebarButton')
          .sidebar('setting', 'mobileTransition', 'overlay')
          ;
          

        //   await (this.$refs.letterlist as any).refresh();
    }
    //  mounted(){
    //    alert("test");
    //        $('.ui.sidebar').sidebar({
    //         context: $('.bottom.segment')
    //       }).sidebar('attach events','.sidebarButton').sidebar('setting', 'mobileTransition', 'overlay');
    //       window.addEventListener("keydown", function(event:any) {
    //         let str = "KeyboardEvent: key='" + event.key + "' | code='" +
    //                     event.code + "'";
    //                 if(event.code=='Backspace'){
    //                     alert(event.code);
    //                     router.replace("ReceivedLettersMobile");
    //                 }
    //     }.bind(this), true);
    // }
    // created(){
    //     window.addEventListener("hashchange", function(e) {
    //     if(e.oldURL.length > e.newURL.length)
    //         alert("back")   
    //     });
    // }
    onCloseFinalizeLetter(){
        this.leftSideMode='';
        this.shallshowparentcomponent=true;
        this.shallShowLetterListRouter=false;
    }
    onSetSelectdLetterChangedLetterListView(letter: Letter){
        this.onSelectdLetterChanged(letter);
        this.shallshowparentcomponent=false;
        this.shallShowLetterListRouter=true;
    }

    async onLetterOwnerSetMobile(e: boolean){
        this.letterOwnerId = this.$store.state.ownerId;
        store.state.eventHub.$emit('refreshFeedEvent')
    }

    async onSetSelectdDraftChangedLetterListView(letter: DraftLetter){
        this.onSelectdDraftChanged(letter);
        this.shallshowparentcomponent=false;
        this.shallShowLetterListRouter=true;
    }

    onEnterpriseFormMobileSelected(form: EnterpriseForm,nextFormInfo?: NextFormInfo,draftFormInfo?: DraftEnterpriseFormInfo){
        this.shallShowSingleEnterpriseForm=true;
        this.onEnterpriseFormSelected(form,nextFormInfo,draftFormInfo)
    }

    onSetSelectdSearchResultChangedLetterListView(searchResult: LetterSearchResult){
        this.shallshowparentcomponent=false;
        this.onSelectdSearchResultChanged(searchResult);
    }

    showOfficeFormlist(){
        this.shallRouteToReciveLettersForm=false;
        this.shallShowSingleEnterpriseForm=false;
        // this.shallShowentErpriseFormLists=true;
        this.leftSideMode = 'enterpriseFormLists';
        this.shallshowparentcomponent=false;
    }
    async onFolderMobileClicked(){
        this.onReturnToParentPage();
        this.leftSideMode = "letterListRouterView";
         $('.ui.sidebar').hide("500");
            store.state.eventHub.$emit('refreshFeedEvent')
        //  $('.ui.sidebar').fadeOut( "slow" );
        //  await (this.$refs.letterlist as any).refresh();
    }
    onForwardClosedMobile(){
        this.leftSideMode="";
        this.shallshowparentcomponent=true;
        this.shallShowLetterListRouter=false;
    }
   onFastSendMobileBtnClick(mode: string){
       this.shallshowparentcomponent=false;
       this.onFastSendBtnClick(mode)
   }

    onReturnToParentPage(){
        this.shallShowLetterListRouter=false;
        this.shallshowparentcomponent=true;
    }

    onSendFormCloseMobile(isNextForm: boolean){
        if(isNextForm){
            const possessionId =  this.selectedLetter.letterPossessionId;
            this.onLetterForwardedMobile(possessionId);
        }
        this.clearLeftSide();
        this.shallshowparentcomponent=true;
        this.shallShowLetterListRouter=false;       
        this.shallshowFastSend=false; 
        // this.$router.replace('ReceivedLettersMobile');
        // this.$router.push('LetterDetailsMobile');
    }

    onFastSendCanceledMobile(){
        this.leftSideMode = "";
        this.shallshowparentcomponent=true;
        this.shallShowLetterListRouter=false;
        this.shallshowFastSend=false;        
    }
   
   onLetterClosedFastMobile(possessionId: string){
        store.state.eventHub.$emit('closeFastEvent',possessionId)
   }

   onDeleteLetterMobile(){
        this.leftSideMode = "";
        store.state.eventHub.$emit('deleteLetterEvent')
   }
   
   onClosedLetterRejectedMobile(possessionId: string){
        store.state.eventHub.$emit('rejectCloseLetterEvent',possessionId);
   }
    
    onLetterForwardedMobile(possessionId: string){
        store.state.eventHub.$emit('forwardLetterEvent',possessionId);
    }

    onRouteToReceiveForm(){
        this.shallshowparentcomponent=true ;
        this.shallShowLetterListRouter=false;
        this.leftSideMode="";
    }

    onDraftDetailsClosedMobile(){
        this.shallshowparentcomponent=true ;
        this.shallShowLetterListRouter=false;
        this.leftSideMode="";
    }
     async onNextFormSelectedMobile(nextFormRequest: any){
        this.isLoading = true;
        this.shallRouteToReciveLettersForm=true;
    const nextFormInfo = await  enterpriseFormService.getNextForm(nextFormRequest);
        this.onEnterpriseFormSelected(nextFormInfo.enterpriseForm,nextFormInfo,undefined);
    }
}

